webpackJsonp([75],{

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(821);


/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _fr = __webpack_require__(567);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('fr', _fr2.default);

/***/ })

},[1621]);


// WEBPACK FOOTER //
// app/datetime.fr-8597f5deecba97e5a612.js